export default "/static/dashboard/build/app/img/v2/c71fb26888a1b4fd30641e5b25d647e6.png";